

import { SET_ACTIVE_USER_ADDRESS, SET_USER_ADDRESSES } from "../main/my-account/store/constants/constants";
import { ActionsUnion } from "./app.action";
import { BrandsLoaded, CATEGORIES_LOADED, CategoriesLoaded, get_paymob_iframe, HotDealsDataLoaded, set_active_location, set_delivery_type, SET_HOME_BRAND_ID, SET_ORDER_TAX_DELIEVERY, SET_REDIRECT, SET_USER_CREDIT, SET_USER_WALLETS, set_website_attributes, show_header_cart, SIGN_IN, SIGN_OUT, SlidersLoaded, SubCategoriesLoaded, Toggle_Wallet_Display_Status, update_add_address_modal_display_status, update_app_loader, update_auth_modal_display_status } from "./constants/app.constant";
import { AppState } from "./constants/app.models";






function getIntialState()
{
  let initialState: AppState  = {
    loader: true,
    website_attribute: [],
    categories : [],
    user: {},
    show_auth_modal: false,
    show_add_address_modal: false,
    show_header_cart: true,
    active_location: {},
    user_addresses: [],
    active_user_address: {},
    active_order_tax_delievery: {},
    redirect: '',
    user_wallets: {},
    user_credit: {},
    home_brand_id: 0,
    paymob_iframe: {},
    delivery_type: '',


    // clean routes
    // new format: page state -> components state
    home: {
      specialSections :  [],
      Categories: {},
      SubCategories: {},
      sliders: {},
      brands: {}
    }

  };

  return initialState
}





export function AppReducer (state = getIntialState(), action: ActionsUnion)
{

  switch ( action.type )
  {

    case update_app_loader:
    return {
      ...state,
      loader: action.data
    };


    case CATEGORIES_LOADED:
    return {
      ...state,
      categories: action.data
    };

    case update_auth_modal_display_status:
      return { ...state, show_auth_modal:action.data };

    case update_add_address_modal_display_status:
      return { ...state, show_add_address_modal:action.data };


    case SIGN_IN:

      let new_user = {
        ...state,
        user: action.data
      };

    return new_user;



    case SIGN_OUT:

      let init_user = {
        ...state,
        user: getIntialState().user
      };

    return init_user;


    case show_header_cart:

      let show_cart = {
        ...state,
        show_header_cart: action.data
      };

    return show_cart;


    case set_active_location:

      let new_location = {
        ...state,
        active_location: action.data
      };

    return new_location;



    case SET_USER_ADDRESSES:
      return {
        ...state,
        user_addresses: action.data
      };


    case SET_ACTIVE_USER_ADDRESS:
      return {
        ...state,
        active_user_address: action.data
      };


    case SET_ORDER_TAX_DELIEVERY:
      return {
        ...state,
        active_order_tax_delievery: action.data
      };



    case SET_REDIRECT:
      return {
        ...state,
        redirect: action.data
      };

    case Toggle_Wallet_Display_Status:
      return {
        ...state,
        user_wallets: {
          ...state.user_wallets,
          wallet_display_status: action.data
        }
      };

    case SET_USER_WALLETS:
      return {
        ...state,
        user_wallets: {
          ...state.user_wallets,
          wallets: action.data
        }
      };


    case SET_USER_CREDIT:
      return {
        ...state,
        user_credit: action.data
      };


    case SET_HOME_BRAND_ID:
      return {
        ...state,
        home_brand_id: action.data
      };

    case get_paymob_iframe:
      return {
        ...state,
        paymob_iframe: action.data
      };

    case set_delivery_type:
      return {
        ...state,
        delivery_type: action.data
      };

    case set_website_attributes:
      return {
        ...state,
        website_attribute: action.data
      };

    case SlidersLoaded:
      return {
        ...state,
        home : {
          ...state.home,
          sliders: action.data
        }
      };

    case SubCategoriesLoaded:
    return {...state,SubCategories:action.data};

    case HotDealsDataLoaded:
        return {...state,specialSections:action.data};

    case CategoriesLoaded:
        return {...state,Categories:action.data};

    case BrandsLoaded:
      return {...state,brands:action.data};

    default:
      return state;

  }



}
